import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  padding: (p) => p.spacing(2, 2, 0, 2),
  width: '100%',
};

export const employeeSize: SxStyle = {
  border: (p) => `1px solid ${p.palette.grey[300]}`,
  borderRadius: (p) => p.spacing(1),
  px: 1.5,
};

export const companyInfo: SxStyle = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
  ml: (p) => p.spacing(3),
};

export const companyInfoWrapper: SxStyle = {
  mt: (p) => p.spacing(1),
  gap: 1.5,
};

export const skeleton: SxStyle = {
  width: (p) => p.spacing(40),
  height: (p) => p.spacing(14),
};
